import API from '../api/api'

export const GET_SURVEY_HISTORY = 'GET_SURVEY_HISTORY'
export const SET_HISTORY = 'SET_HISTORY'
export const SET_SURVEY_LOADING = 'SET_SURVEY_LOADING'

export const initialState = {
  history: [],
  loadedAllHistory: false,
  loadingHistory: false,
}

const removeDuplic = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.id)) {
        tempArr.push(obj.id)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURVEY_HISTORY:
      return {
        ...state,
        history: removeDuplic(action.history),
        loadedAllHistory: action.loadedAllHistory,
        loadingHistory: false,
      }
    case SET_HISTORY:
      return {
        ...state,
        history: action.history,
      }
    case SET_SURVEY_LOADING:
      return {
        ...state,
        loadingHistory: action.loadingHistory,
      }
    default:
      return state
  }
}

// Actions
export const getSurveyHistory = (
  page = 1,
  buildingId = 0,
  query = '',
  pageSize = 50,
  types,
  status,
  dateRange,
) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getSurveyHistory(start, pageSize, buildingId, query, types, status, dateRange)
      .then((data) => {
        const { surveys } = data.data

        dispatch({
          type: GET_SURVEY_HISTORY,
          history: surveys,
          loadedAllHistory: surveys.length < pageSize,
        })
        return Promise.resolve(data.data)
      })
      .catch((err) => {
        throw new Error(err)
      })
      .finally(dispatch(setLoading(false)))
  }
}

export const setLoadingState = (loadingHistory) => {
  return function (dispatch) {
    dispatch(setLoading(loadingHistory))
  }
}

export const setHistory = (history) => {
  return {
    type: SET_HISTORY,
    history,
  }
}

const setLoading = (loadingHistory) => {
  return {
    type: SET_SURVEY_LOADING,
    loadingHistory,
  }
}

// Selectors
export const selectSurveyHistory = (state) => state.survey.history

export const selectStatusOfLoading = (state) => state.survey.loadingHistory

export const selectStatusIsLoadedAll = (state) => state.survey.loadedAllHistory

export default surveyReducer
